import {
  type CommerceMapperContext,
  type CommerceInsulation,
  ProductType,
} from '@analytics/models';
import {
  analyticsRoundNumericValue,
  AnalyticsUtils,
  defaultCommerceMapperContext,
  parseTrackProductConfig,
} from '@analytics/utils';
import { inject, Injectable } from '@angular/core';
import type { InsulationProductWithCalculations } from '@innogy/feh/temporary-core-modules';

@Injectable({
  providedIn: 'root',
})
export class InsulationProductTrackingConfig {
  readonly #analyticsUtils = inject(AnalyticsUtils);

  config = parseTrackProductConfig({
    productToCommerce: (
      product: InsulationProductWithCalculations,
      context: CommerceMapperContext
    ): CommerceInsulation => {
      context = {
        ...context,
        listName: this.#analyticsUtils.prefixWithAbbreviation(context.listName),
      };
      return InsulationProductTrackingConfig.mapToCommerce(product, context);
    },
  });

  static mapToCommerce = (
    product: InsulationProductWithCalculations,
    context: CommerceMapperContext = defaultCommerceMapperContext
  ): CommerceInsulation => ({
    productNaam: product.content.title,
    productID: product.suiteCrmId,
    productType: ProductType.Insulation,
    productCategorie: product.productType.value as any,
    productPositie: `${context.index}`,
    productAantal: `${context.numberOfProducts}`,
    productLijst: context.listName,
    prijs: analyticsRoundNumericValue(product.installationCosts),
  });
}
